import { lazy as e } from "/home/runner/work/oko-web/oko-web/node_modules/react/index.js";
//#region src/lib/hooks/lazyRetry.ts
var t = function(t, n = "") {
	return e(() => new Promise((e, r) => {
		let i = JSON.parse(window.sessionStorage.getItem(`retry-lazy-refreshed-${n}`) || "false");
		t().then((t) => {
			window.sessionStorage.setItem(`retry-lazy-refreshed-${n}`, "false"), e(t);
		}).catch((e) => {
			if (!i) return window.sessionStorage.setItem(`retry-lazy-refreshed-${n}`, "true"), window.location.reload();
			r(e);
		});
	}));
};
//#endregion
export { t as lazyRetry };
